import { localDb } from '../db/localDb';
import { hasUnresolvedOperations } from '../services/durableQueue';

export async function shellUpdateSafe() {
  try {
    const blocked=await hasUnresolvedOperations();
    await localDb.runtimeCache.put({key:'shell-update-barrier',kind:'shell',blocked,updatedAt:Date.now()});
    return !blocked;
  }catch{return false;}
}
export async function registerOfflineShell() {
  if(!import.meta.env.PROD||!('serviceWorker' in navigator))return;
  await shellUpdateSafe();
  navigator.serviceWorker.addEventListener('message',event=>{
    if(event.data?.type==='SHELL_UPDATE_CHECK')shellUpdateSafe().then(safe=>event.ports[0]?.postMessage({safe}));
  });
  try {
    const registration=await navigator.serviceWorker.register('/sw.js',{updateViaCache:'none'});
    const ready=await navigator.serviceWorker.ready;
    const controller=navigator.serviceWorker.controller||ready.active;
    if(controller){const channel=new MessageChannel();channel.port1.onmessage=event=>window.dispatchEvent(new CustomEvent('workbill:shell-readiness',{detail:{ready:event.data?.ready===true}}));controller.postMessage({type:'REPAIR_SHELL'},[channel.port2]);}
    const offer=async()=>{
      const waiting=registration.waiting;
      if(waiting&&await shellUpdateSafe())waiting.postMessage({type:'ACTIVATE_WHEN_SAFE'});
    };
    registration.addEventListener('updatefound',()=>registration.installing?.addEventListener('statechange',offer));
    window.addEventListener('workbill:bill-sync-status',()=>shellUpdateSafe());
    setInterval(async()=>{if(await shellUpdateSafe()){await registration.update().catch(()=>{});await offer();}},60000);
    await offer();
  }catch(error){window.dispatchEvent(new CustomEvent('workbill:shell-error',{detail:'Offline shell is not ready. Connect once and allow device storage before relying on offline reload.'}));}
}
